import React from 'react'
import styles from './UIGameEndHeader.module.scss'
import {AdBox} from './AdBox'
import {ActionButtons} from './ActionButtons'
import {Logo} from './Logo'

export function UIGameEndHeader({disableAnimation}: {disableAnimation: boolean}) {
    return (
        <div className={styles.header}>
            <AdBox disableAnimation={disableAnimation}/>
            <Logo disableAnimation={disableAnimation}/>
            <ActionButtons disableAnimation={disableAnimation}/>
        </div>
    )
}
